import readRequiredStringEnv from './services/readRequiredStringEnv';

const defaultCountryCode = readRequiredStringEnv(
  process.env.NEXT_PUBLIC_DEFAULT_COUNTRY_CODE,
  'NEXT_PUBLIC_DEFAULT_COUNTRY_CODE'
);
export default defaultCountryCode;
